import { Box, Typography, Alert } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { FormTitle } from "ui-components/Form";
import { InboundHeaderCard } from "ui-components/Layout";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ExcelJS from "exceljs";
import MDButton from "components/MDButton";
import { StripedDataGrid } from "ui-components/data-grids/StripedCheckboxDataGrid";
import {
  downloadCORecvDivisionGroupTemplate,
  //validateRecvDivisionUploadData,
} from "services/data.inbound.service";
import {
  validateRecvDivisionUploadData
} from "services/data.internal.service";
import { useMutation } from "@tanstack/react-query";
import dayjs from "dayjs";
import { useCustomerValue } from "providers/CustomerContext";
function ReceivingDivisionGroup({ details, uploadData, setUploadData ,divReqValue}) {
  //console.log("divReqValue",divReqValue);
  //console.log("detail from receivingdivisiongroup",details);
  //console.log("uploadData from receivingdivisiongroup",uploadData);
  //console.log("setUploadData from receivingdivisiongroup",setUploadData);
  const { customerCode } = useCustomerValue();

  const [dynamicHeaders, setDynamicHeaders] = useState([]); // 存储表头
  const [errorsList, setErrorsList] = useState([]);

  const validateMutation = useMutation(validateRecvDivisionUploadData, {});

  const { handleSubmit, control, watch, resetField } = useForm({
    defaultValues: { excelFile: null },
  });

  useEffect(() => {
    console.log(dynamicHeaders);
    console.log(uploadData);
    if (dynamicHeaders.length === 0 && uploadData.length > 0

    ) {
      setDynamicHeaders(Object.keys(uploadData[0]));
    }
  }, [uploadData]);

  const selectedFile = watch("excelFile");

  const handleFileUpload = async (file) => {
    if (!divReqValue) {
      setUploadData([]);
      resetField("excelFile");
      alert("Division file is not required. No need to upload. You need to activate the Division File Upload if you wish to upload file.");
      return;
    }
    //console.log("divReqValue from handlefileupload",divReqValue);
    //console.log("file",file);
    const workbook = new ExcelJS.Workbook();

    try {
      const arrayBuffer = await file.arrayBuffer();
      await workbook.xlsx.load(arrayBuffer);
      const worksheet = workbook.getWorksheet(1);

      const tempRows = [];
      const invalidSkus = [];
      let tempHeaders = [];

      // 1. 获取第一行作为表头
      const firstRow = worksheet.getRow(1);
      if (firstRow) {
        firstRow.eachCell((cell) => {
          tempHeaders.push(cell.value?.toString() || "");
        });
      }

      // 2. 遍历数据行
      // worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
      //   if (rowNumber === 1) return; // 跳过表头

      //   const rowObject = {};
      //   let currentSku = "";
      //   let isRowGenericValid = true;

      //   // 根据表头索引将单元格值映射到对象
      //   tempHeaders.forEach((headerName, index) => {
      //     const cellValue = row.getCell(index + 1).value;
      //     console.log(cellValue);
      //     rowObject[headerName] = cellValue;

      //     if (headerName === "SKU Code") {
      //       currentSku = cellValue?.toString().trim();
      //     } else {
      //       const numericValue =
      //         typeof cellValue === "object" ? cellValue?.result ?? "" : cellValue;
      //       if (
      //         (numericValue !== null &&
      //           numericValue !== undefined &&
      //           isNaN(Number(numericValue))) ||
      //         numericValue === ""
      //       ) {
      //         invalidSkus.push(
      //           `Row ${rowNumber}: Column "${headerName}" must be a number (Value: ${numericValue})`
      //         );
      //         isRowGenericValid = false;
      //       }
      //     }
      //   });

      //   // 校验 SKUCode
      //   if (!details.some((d) => d.skuCode === currentSku)) {
      //     invalidSkus.push(currentSku || `Row ${rowNumber}: empty SKU Code`);
      //   } else if (isRowGenericValid) {
      //     tempRows.push(rowObject);
      //   }
      // });

      worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
        if (rowNumber === 1) return; // 跳过表头

        const rowObject = {};
        let currentSku = "";
        let isRowGenericValid = true;

        // 根据表头索引将单元格值映射到对象
        tempHeaders.forEach((headerName, index) => {
          const rawValue = row.getCell(index + 1).value;

          // --- 核心修改：处理公式并设置默认值 0 ---
          let cellValue =
            typeof rawValue === "object" && rawValue !== null ? rawValue.result ?? 0 : rawValue;

          // 如果值是 null, undefined 或空字符串，统统给 0
          if (cellValue === null || cellValue === undefined || cellValue === "") {
            cellValue = 0;
          }
          // ---------------------------------------

          rowObject[headerName] = cellValue;

          if (headerName === "SKU Code") {
            // SKU 逻辑保持字符串处理，如果是 0 会变成 "0"
            currentSku = cellValue.toString().trim();
          } else {
            // 校验逻辑：因为已经有了默认值 0，所以只需要判断是否为“非数字”
            if (isNaN(Number(cellValue))) {
              invalidSkus.push(
                `Row ${rowNumber}: Column "${headerName}" must be a number (Value: ${cellValue})`
              );
              isRowGenericValid = false;
            }
          }
        });

        // 校验 SKUCode 是否在合法列表中
        if (!details.some((d) => d.skuCode === currentSku)) {
          invalidSkus.push(`Row ${rowNumber}: SKU Code "${currentSku}" not found`);
        } else if (isRowGenericValid) {
          tempRows.push(rowObject);
        }
      });

      // 3. 根据校验结果更新状态
      if (invalidSkus.length > 0) {
        setErrorsList(invalidSkus);
        setUploadData([]);
        setDynamicHeaders([]); // 失败则清空表头
      } else {
        validateMutation.mutate(
          {
            divisionQuantity: JSON.stringify(tempRows),
            AdjustmentDetails: details
              //.filter((d) => d.status === "Open")
              .map((d) => ({
                skuCode: d.skuCode,
                quantity: d.quantity,
                adjustQuantity: d.adjustQuantity,
                baseUOM: d.baseUOM,
                cartonID: d.cartonID,
                customerCode: d.customerCode,
                expiryDate: d.expiryDate,
                locationID: d.locationID,
                mln: d.mln,
                oln: d.oln,
                vendorCode: d.vendorCode,
                warehouseCode: d.warehouseCode,
                zoneID: d.zoneID,
              })),
          },
          {
            onSuccess: (data) => {
              if (data.data.data && data.data.data.length > 0) {
                setErrorsList(data.data.data);
                setUploadData([]);
                setDynamicHeaders([]); // 失败则清空表头
                return;
              }
              setErrorsList([]);
              setDynamicHeaders(tempHeaders); // 成功则保存表头
              setUploadData(tempRows); // 成功则保存数据
            },
            onError: () => {},
          }
        );
      }
    } catch (err) {
      //console.error("解析出错:", err);
      alert("Invalid file format");
    } finally {
      // 无论成功还是失败，都清除 React Hook Form 里的文件状态
      resetField("excelFile");
    }
  };

  const onSubmit = (data) => {
    if (data.excelFile) {
      handleFileUpload(data.excelFile);
    }
  };
  const downloadMutation = useMutation(downloadCORecvDivisionGroupTemplate, {
    onSuccess: () => {
       //console.log("from download function",downloadCORecvDivisionGroupTemplate);
      //setLoading(null);
    },
  });

  const handleExport = async () => {
    if (uploadData.length === 0) {
      alert("no data");
      return;
    }

    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // 1. 设置表头
      // 使用 dynamicHeaders 生成列定义
      worksheet.columns = dynamicHeaders.map((header) => ({
        header: header,
        key: header,
        width: 20,
      }));

      // 2. 添加数据
      worksheet.addRows(uploadData);

      // 3. 样式美化（可选）
      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE0E0E0" },
        };
      });

      // 4. 生成 Buffer
      const buffer = await workbook.xlsx.writeBuffer();

      // 5. 使用原生 JS 触发下载
      // 将 Buffer 转为 Blob
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // 创建指向 Blob 的 URL
      const url = window.URL.createObjectURL(blob);

      // 创建一个隐藏的 <a> 标签
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = `DivisionAdjustment_${dayjs().format("YYYYMMDDHHmmss")}.xlsx`; // 文件名

      // 将标签加入 DOM 并触发点击，然后移除
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);

      // 释放内存中的 URL 对象
      window.URL.revokeObjectURL(url);
    } catch (error) {
      //console.error("导出失败:", error);
      alert("error");
    }
  };
  return (
    <InboundHeaderCard>
      <FormTitle title="Upload Division Group Quantity" />

      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 3 }}>
          <Controller
            name="excelFile"
            control={control}
            render={({ field: { onChange } }) => (
              <MDButton
                component="label"
                color="info"
                variant="gradient"
                startIcon={<CloudUploadIcon />}
              >
                Choose File
                <input
                  type="file"
                  hidden
                  accept=".xlsx"
                  onChange={(e) => {
                    onChange(e.target.files[0]);
                    e.target.value = ""; // 允许重复上传同一个文件
                  }}
                />
              </MDButton>
            )}
          />

          <MDButton type="submit" color="secondary" variant="gradient" disabled={!selectedFile}>
            Upload
          </MDButton>

          <MDButton
            color="primary"
            variant="gradient"
            onClick={() => {
              const formattedDetails = details.map(item => ({
    skuCode: item.skuCode
  }));

  // console.log("sending payload", {
  //   customerCode,
  //   details: formattedDetails
  // });

              downloadMutation.mutate(
                { customerCode,details: formattedDetails },
                {
                  onSuccess: (data) => {
                    const blob = new Blob([data.data]);
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                      "download",
                      `Adjustment_${dayjs().format("YYYYMMDDHHmmss")}.xlsx`
                    );
                    document.body.appendChild(link);
                    link.click();
                  },
                }
              );
            }}
          >
            Download Division Group Template
          </MDButton>

          <MDButton color="success" variant="gradient" onClick={handleExport}>
            Export
          </MDButton>

          {selectedFile && (
            <Typography variant="caption" fontWeight="bold">
              File: {selectedFile.name}
            </Typography>
          )}
        </Box>
      </form>

      {/* 错误显示 */}
      {errorsList.length > 0 && (
        <Alert severity="error" sx={{ mb: 2 }}>
          SKU Code not in adjustment details / not found / not tally
          <ul>
            {errorsList.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </Alert>
      )}

      {/* 只有校验通过且有表头时才显示表格 */}
      {dynamicHeaders.length > 0 && uploadData.length > 0 && (
        <Box sx={{ height: 400, width: "100%", mt: 1 }}>
          <StripedDataGrid
            // 1. 动态生成列定义
            columns={dynamicHeaders.map((header) => ({
              field: header,
              headerName: header,
              flex: 1, // 自动撑开宽度
              minWidth: 120,
              // 如果单元格是对象（比如 Excel 公式），进行格式化显示
              valueFormatter: (value) =>
                typeof value === "object" ? JSON.stringify(value) : value,
            }))}
            // 2. 动态生成行数据，并确保每行都有唯一的 id
            rows={uploadData.map((row, index) => ({
              id: index, // DataGrid 必须有 id
              ...row,
            }))}
            // 3. 其他常用配置
            pageSizeOptions={[10, 20, 30, 40, 50]}
            initialState={{
              pagination: { paginationModel: { pageSize: 10 } },
            }}
            disableRowSelectionOnClick
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f5f5f5",
              },
            }}
          />
        </Box>
      )}
    </InboundHeaderCard>
  );
}

export default ReceivingDivisionGroup;
